import { render } from "./RecomendacionesCategoria.vue?vue&type=template&id=5061c863"
import script from "./RecomendacionesCategoria.vue?vue&type=script&lang=js"
export * from "./RecomendacionesCategoria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__